import PrettyCheckbox from 'pretty-checkbox-vue'
import Vue from 'vue'

Vue.use(PrettyCheckbox)
